import BlogArticleCardSkeleton from '@components/skeletons/articleCardSkeleton';
import { distinctUntilChanged, filter, map, skip } from 'rxjs';
import { store$ } from '@redux/store';
import { selectPageSize,
  onSuccesedArticleSearchResults$, onloadingArticleSearchResults$ } from 'features/articleSearchResultsFacets';

const articlesContainerQuerySelector = '[data-component="blog-article-search-results"]';
const skeleton = new BlogArticleCardSkeleton();
skeleton.setContainer(articlesContainerQuerySelector);
skeleton.setCardCounts(20);

const removeBlogArticleCardSkeletons = function() {
  skeleton.destroy()
};

const renderBlogArticleCardSkeletons = function() {
  const articlesContainer = document.querySelector(articlesContainerQuerySelector);
  if(articlesContainer){
    articlesContainer.removeAttribute('hidden');
  }
  skeleton.create();
};

const updateBlogArticleCardCountSkeleton = function(pageSize) {
  skeleton.setCardCounts(pageSize);
}

// observer to map search command but only emmit if the page have been changed
const onPageSizeChange$ = store$.pipe(
  map(selectPageSize),
  filter(Boolean),
  distinctUntilChanged(),
  skip(1)
);

onPageSizeChange$.subscribe(updateBlogArticleCardCountSkeleton);
onloadingArticleSearchResults$.subscribe(renderBlogArticleCardSkeletons);
onSuccesedArticleSearchResults$.subscribe(removeBlogArticleCardSkeletons);